import { SlideGroupData } from '@/features/_data/useUnitData';
import { Flex } from '@/ui/Flex/Flex';
import { Sidebar } from '@/ui/Sidebar/Sidebar';
import { T } from '@/ui/Text/Text';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Select from 'react-select';
import { SensorType } from '@/types/SensorType';
import { MagicModel } from '@/types/MagicModel';
import { selectorStyle, StyledTagRow } from './styles';

function SensorGroupMappingSidebar({
  slideGroup,
  isSidebarOpen,
  setIsSidebarOpen,
  magicModels,
  assignedTag,
  mapSlidesToChannelsAndRename,
}: {
  slideGroup: SlideGroupData;
  isSidebarOpen: boolean;
  setIsSidebarOpen: React.Dispatch<typeof isSidebarOpen>;
  magicModels: MagicModel[];
  assignedTag: MagicModel | null;
  mapSlidesToChannelsAndRename: (tag: string, newName: string) => void;
}) {
  return (
    <Sidebar
      isOpen={isSidebarOpen}
      onClose={() => {
        setIsSidebarOpen(false);
      }}
      title={
        <FormattedMessage
          defaultMessage="Slidegroup {slideName}"
          values={{ slideName: slideGroup.name }}
          id="M8UhMo"
        />
      }
    >
      <Flex direction="column" gap={8}>
        <T>
          Select a sensor that you want to add to all slides in the group. The
          channels will be automatically assigned in order.
        </T>
        <StyledTagRow>
          <Select
            isSearchable={false}
            options={magicModels
              .filter((MM) => MM.sensorType === SensorType.NEXMO_NFC)
              .map((model) => ({
                value: model,
                label: model.modelName,
              }))}
            placeholder={assignedTag?.modelName || 'Magic Model Name'}
            styles={selectorStyle}
            value={
              assignedTag
                ? { value: assignedTag, label: assignedTag.modelName }
                : null
            }
            onChange={(e) => {
              const newAssignedTag = e?.value as {
                modelName: string;
                sensorId: string;
                sensorType: SensorType;
              };
              mapSlidesToChannelsAndRename(
                newAssignedTag.sensorId,
                newAssignedTag.modelName,
              );
              setIsSidebarOpen(false);
            }}
          />
        </StyledTagRow>
      </Flex>
    </Sidebar>
  );
}

export default SensorGroupMappingSidebar;
